export const FETCHED_USER = 'FETCHED_USER';
export const UPDATED_USER = 'UPDATED_USER';



// WEBPACK FOOTER //
// ./src/containers/myaccount/types.js